import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f892e088"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite-control text-big" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "col-sm-8 col-sm-offset-1" }, "Invite with link")
], -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-8 col-sm-offset-1" }
const _hoisted_5 = { class: "invite-link-wrapper form-control form-control-lg" }
const _hoisted_6 = ["placeholder", "value"]
const _hoisted_7 = { class: "col-sm-2 col-xs-12 text-center copy-link-button" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 col-sm-offset-1" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("small", null, "Copy this link and send it via your own email or messaging.")
    ])
  ])
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"margin-top":"1rem"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "col-sm-8 col-sm-offset-1" }, "Invite with email")
], -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-10 col-sm-offset-1" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("small", null, "Enter your colleagues' email addresses to send them an invitation.")
    ])
  ])
], -1))

import type { InviteControlApiModel } from "../../api-models";
import useInviteControlBase from "./useInviteControlBase";
import TeamInviteSender from "./team-invite-sender.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'team-invite-control',
  props: {
    model: {},
    showExamples: { type: Boolean, default: false }
  },
  emits: ["invite-action", "previous-invites", "deleted-event"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { copied, copyToClipboard, onSendEvent, selectCodeUrl } = useInviteControlBase(props.model);

function emitInviteAction() {
  emit("invite-action");
}

function onPreviousInvites(): void {
  emit("previous-invites");
}

function onDeletedEvent(): void {
  emit("deleted-event");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("input", {
            id: "inviteLink",
            ref: "inviteLink",
            type: "text",
            class: "invite-link-input",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(selectCodeUrl)())),
            placeholder: _ctx.model.inviteUrl,
            value: _ctx.model.inviteUrl,
            "aria-label": "Invite link"
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          role: "button",
          href: "javascript:void(0)",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(copyToClipboard)(emitInviteAction))),
          class: _normalizeClass(["btn btn-lg invite-button", { 'btn-default-copy': !_unref(copied), 'btn-default-tick': _unref(copied) }]),
          "data-test": "copy-invite-link"
        }, _toDisplayString(_unref(copied) ? "Copied!" : "Copy link"), 3)
      ])
    ]),
    _hoisted_8,
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(TeamInviteSender, {
        "user-tags": _ctx.model.userTags,
        sendUrl: _ctx.model.sendUrl,
        deleteUrl: _ctx.model.deleteUrl,
        onSendStarted: _cache[2] || (_cache[2] = ($event: any) => (_unref(onSendEvent)(emitInviteAction))),
        onDeleteStarted: onDeletedEvent,
        onDeleteCompleted: onDeletedEvent,
        onPreviousInvites: onPreviousInvites
      }, null, 8, ["user-tags", "sendUrl", "deleteUrl"])
    ]),
    _hoisted_11
  ]))
}
}

})